export default "__VITE_ASSET__0123b485__"